import { writable } from 'svelte/store'

// Default
export const userDefault = () => {
  return {
    anonymous: true,
    authenticated: false,
    email: null,
    id: null,
    image: null,
    initialized: false,
    name: null,
    reference: null,
    token: null,
    verified: false,
  }
}

export const User = writable( userDefault() )
